module.exports = __webpack_public_path__ + "img/loop.3b5a362.png";